import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { SlDrawer } from '@shoelace-style/shoelace/dist/react';
import Paginator from "../../shared/Paginator";
import { ScrollContainer } from 'react-indiana-drag-scroll';
import { Pagination, Navigation } from "swiper";
import { useDispatch, useSelector } from 'react-redux';
import api from "../../services/api"
import { Toast } from '../../shared/Toast'
import { formatDateWithTime, ISODateString } from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { SetComponentId } from '../../redux/counterSlice'
import config from "../../config";
import { Swiper, SwiperSlide } from 'swiper/react';
import CryptoJS from 'crypto-js';




import PreviewFrameEdit from "../PreviewFrameEdit";

import createdSVG from "../../../src/assets/images/created.svg"
import runningSVG from "../../../src/assets/images/running.svg"
import pausedSVG from "../../../src/assets/images/paused.svg"
import completedSVG from "../../../src/assets/images/completed.svg"
import scheduledSVG from "../../../src/assets/images/scheduled.svg"
import approved from "../../../src/assets/images/request.svg"
import { SlOption, SlSelect, SlInput,SlIcon } from '@shoelace-style/shoelace/dist/react';
import { campaignStatus, reportStatus, roles, stateOptions, languageOptions, removeCommonLocation } from "../../utils/constants";

const actiontypeoptions = ["Shuffle", "Round robin"]
export const lineItemCreativeContext = React.createContext();


function DiscountApproveCampaigns() {

    const dispatch = useDispatch()
    dispatch(SetComponentId(26))
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [tarshow, setTarshow] = useState(false)
    const [targetdetails, setTargetdetails] = useState({
      age: { min: '', max: '' }
    })
    const [actual_target, setactual_target] = useState({})
    const [search, setSearch] = useState("");
    const [startDateFormatted, setStartDateFormatted] = useState("");
    const [endDateFormatted, setEndDateFormatted] = useState("");
    const [status, setStatus] = useState(-1);
    const [currentPage, setCurrentPage] = useState(0);
    const HeaderSearch = useSelector(state => state.Head.adssearch)
    const [initialRender, setInitialRender] = useState(true);
    const genderOptions = ["All", "Male", "Female"]
    const osOptions = ["All", "Android", "IOS"]
    const appCategoryOptions = ["All", "News", "Business", "Sports", "Cinema", "Special", "Politics"]
    const langoptions = ["", "Telugu", "Tamil", "Hindi", "Kannada", "Malayalam", "Marathi", "Bengali", "Gujarati", "", "Odia"]
    const [previewdata, setPreview] = useState({});
    const [localHeadsList, setLocalHeadsList] = useState([])
    const [brandsList, setBrandsList] = useState([])
    const [campCategory, setCampCategory] = useState([])
    const [creative_Names, setCreative_Names] = useState([])
    const [discStatusFilter, setDiscStatusFilter] = useState(0)
    var timeslots = [{ sdate: '', edate: '' }] 
  
    const SALES = useSelector(state => state.Head.opssales)
  
    const [actual_hidden_target, setactual_hidden_target] = useState({})
    const [hidden_target_preview, setHidden_target_preview] = useState({})
    const [showActionsMenu, setShowActionsMenu] = useState(-1)
    const [discountObjDetails,setDiscountObjDetails] = useState({})
    const [rejectMessage, setRejectMessage] = useState("")
    const [rejectClick, setRejectClick] = useState(false)
    const [approveMessage, setApproveMessage] = useState("")
    const [approveClick, setApproveClick] = useState(false)


    const navigate = useNavigate()
   useEffect(()=>{
    let role = localStorage.getItem('role')
    if( !(role === roles.ops || role === roles.salesperson || role === roles.legalperson)){
        navigate('/')
    }
   })
  
const getData = async (search = '', page = 0, discount_status = discStatusFilter, status1 = status) => {
    setShowActionsMenu(-1)
    try {
      setLoader(true);
      let res = await api({
        url: '/lineitems/getDiscountLineItems',
        method: 'POST',
        responseType: 'json',
        data: {
          search,
          page,
          limit: config.PER_PAGE,
          status: status1,
          discount_status
        }
      });
      if (res.code === 200) {
        setData(res.data.data);
        setTotalPages(Math.ceil(parseInt(res.data.total) / config.PER_PAGE));
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
      if (error.response.status === 401)
        navigate("/")
    }
  }
  useEffect(() => {
    getData();
    // downloadReport();
    setInitialRender(false)
  }, [])
  useEffect(() => {
    Header()
  }, [HeaderSearch])

  const ViewDiscount = async(campaign_id, index) =>{
    setDiscountObjDetails({company_name : data[index].company_name,
      campaign_name : data[index].campaign_name,
      sales_name : data[index].sales_name,
      discount_no : data[index].discount_obj?.discount_no,
      discReq : data[index].discount_obj?.discReq,
      discApp : data[index].discount_obj?.discApp,
      rejMess: data[index].discount_obj?.rejMess,
      actualPrice : data[index].discount_obj?.actualPrice,
      time: data[index].discount_obj?.time,
      type: data[index].type,
      campaign_type : data[index].campaign_type,
      discountPrice: data[index].discount_obj?.discountPrice,
      campaign_id: data[index].campaign_id,
      order_name: data[index].order_name,
      discReas: data[index].discount_obj?.discReas,
      discsign: data[index].discount_obj?.discsign,
      name: data[index].discount_obj?.name,
      role: data[index].discount_obj?.role,
      cst_name: data[index].discount_obj?.cst_name,
      approvName: data[index].discount_obj?.approvName
    })
    // const updateResult = await api({
    //     url : "/user/campaign_creation/approveDiscount",
    //     method: 'POST',
    //     responseType: 'json',
    //     data: {campaign_id}
    // })
  }
const ApproveRejectDisc = async (discountObjDetails, action) => {
  try {
    let reqObj = {
      payload: {
        campaign_id: +discountObjDetails.campaign_id,
        discount_no: +discountObjDetails.discount_no,
        discountPrice: +discountObjDetails.discountPrice,
        time: discountObjDetails.time,
        actualPrice: +discountObjDetails.actualPrice,
        discReq: +discountObjDetails.discReq,
        role: discountObjDetails.role
      },
      action
    }
    if (action === "reject")
      reqObj.message = rejectMessage
      if (action === "approve")
      reqObj.message = approveMessage
    const actionResult = await api({
      url: "/lineitems/approveRejectDiscByPanel",
      method: 'POST',
      responseType: 'json',
      data: reqObj
    })
    if (actionResult?.code === 200) {
      const respObject = actionResult?.data
      if (respObject.discStatus === 1) {
        Toast("error", "Already Approved")
        return
      } else if (respObject.discStatus === 2) {
        Toast("error", "Already Rejected")
        return
      } else if (respObject.discStatus === 3) {
        Toast("error", "Discount has been Expired 111")
        return
      } else if (respObject.discStatus === 4) {
        Toast("error", "Discount has been Modified")
        return
      } else if (respObject.discStatus === 5) {
        Toast("error", "UnAuthorized Action")
        return
      } else if (respObject.discStatus === 6) {
        Toast("success", action === "reject" ? "Rejected Successfully" : "Approved Successfully")
        getData(search, 0)
        setDiscountObjDetails({})
        return
      }
    }

  } catch (error) {
    console.log("Error @ ApproveRejectDisc", error)
  }
}

const result1 = {
    datavariable: [],
    type: "",
    action: "",
    id: "",
    start: {
        "campaign_name": "",
        "type": "",
        "campaign_type": "",
    },
    budget: {
        "total_budget": 0,
        "daily_budget": 0,
        "cpm": 0,
        "tot_imp_cap": 0,
        "tot_click_cap": 0,
        "daily_imp_cap": 0,
        "cpd": 0,
        "daily_click_cap": 0,
        "cpc_price": 0
    },
    creatselect: {
        "creative_ids": [],
        "position": 0,
        "positiontype": "",
        "frequency_cap": 0,
        "ad_code": "",
        "line_item_code": "",
        "creative_type": "",
        "frequency_cap_type": "",
        "post_type": "",
        "news_type": "",
    },
    date: {
        start_date: "",
        end_date: "",
        datelist: [{ sdate: "", edate: "" }]
    },
    target: {
        "target_id": 0,
        "locations": [],
        "lang_ids": [],
        "os": "",
        "app": [],
        "minspend": []
    }
}

const editAction = (index, id, act) => {
    result1.status = data[index].status
    result1.action = act
    result1.id = id
    result1.type = data[index].type;
    result1.start.campaign_name = data[index].campaign_name
    result1.start.type = data[index].type
    result1.start.brand_id = +data[index].brand_id
    result1.start.campaign_type = data[index].campaign_type
    result1.budget.total_budget = data[index].total_budget
    result1.budget.daily_budget = data[index].daily_budget
    result1.budget.cpm = data[index].cpm
    result1.budget.tot_imp_cap = data[index].tot_imp_cap
    result1.budget.tot_click_cap = data[index].tot_click_cap
    result1.budget.daily_imp_cap = data[index].daily_imp_cap
    result1.budget.daily_click_cap = data[index].daily_click_cap
    result1.creatselect.cpd = data[index].cpd
    result1.budget.cpc_price = data[index].cpc_price;
    result1.creatselect.position = data[index].position
    result1.creatselect.creative_type = data[index].creative_type
    result1.creatselect.positiontype = data[index].position_type
    result1.creatselect.frequency_cap_type = data[index].frequency_cap_type
    result1.creatselect.frequency_cap = data[index].frequency_cap
    result1.creatselect.ad_code = data[index].ad_code
    result1.creatselect.line_item_code = data[index].line_item_code
    result1.creatselect.dfp_creative_ids = data[index].dfp_creative_ids ? data[index].dfp_creative_ids.join(',') : data[index].dfp_creative_ids
    result1.creatselect.post_type = data[index].post_type
    result1.creatselect.news_type = data[index].news_type
    result1.creatselect.creative_ids = data[index].creative_ids
    result1.creatselect.action_type = data[index].action_type
    result1.creatselect.encryption = data[index].encryption
    result1.creatselect.priority = data[index].priority ? data[index].priority : 1
    result1.date.end_date = data[index].end_date
    result1.date.start_date = data[index].start_date
    let dtime = data[index].day_time_slots
    result1.date.datelist = dtime
    result1.discount_obj = data[index].discount_obj
    result1.brand_name = data[index].brand_name
    getTarget(id, act, index)
}
const getTarget = async (campaign_id, action, index) => {
    try {
        let res = await api({
            url: '/user/target/getTarget',
            method: 'POST',
            responseType: 'json',
            data: { campaign_id: campaign_id }
        })
        
        if (Object.keys(res.data).length) {
            setactual_target(await removeCommonLocation(res.data.lang_ids, res.data.state_ids, res.data.district_ids, res.data.mandal_ids, res.data.village_ids, res.data.exclude))
            setTargetdetails(res.data)
        }
            if (JSON.stringify(res.data) !== '{}') {
                result1.target.state_ids = res.data.state_ids
                result1.target.district_ids = res.data.district_ids
                result1.target.mandal_ids = res.data.mandal_ids
                result1.target.village_ids = res.data.village_ids
                result1.target.lang_ids = res.data.lang_ids
                result1.target.os = res.data.os
                result1.target.minspend = res.data.minspend
                result1.target.app = res.data.app_category
                result1.target.min_age = res.data.age.min === '' ? '' : parseInt(res.data.age.min)
                result1.target.max_age = res.data.age.max === '' ? '' : parseInt(res.data.age.max)
                result1.target.gender = res.data.gender
                result1.target.target_id = res.data.target_id
                result1.target.exclude = res.data.exclude
                result1.target.constituency_ids = res.data.constituency_ids
                if (localStorage.getItem('role') === roles.ops) {
                    try {
                        let hidden_target_result = await api({
                            url: '/user/target/getHiddenTarget',
                            method: 'POST',
                            responseType: 'json',
                            data: { campaign_id: campaign_id }
                        })
                        if (Object.keys(hidden_target_result.data).length) {
                            setactual_hidden_target(await removeCommonLocation(hidden_target_result.data.lang_ids, hidden_target_result.data.state_ids, hidden_target_result.data.district_ids, hidden_target_result.data.mandal_ids, hidden_target_result.data.village_ids, 0))
                            setHidden_target_preview(hidden_target_result.data)
                        }
                    } catch (error) {
                        console.error("Error @ hidden_target api in campaigns table")
                    }
                }

            }
        setPreview(result1)
        

    }
    catch (erre) {
        console.error(erre)
    }
}
// const removeCommonLocation = (lang_ids, state_ids, district_ids, mandal_ids, village_ids, exclude) => {
//     return new Promise((resolve, reject) => {
//         try {
//             let mandalRes = [], districtRes = [], statesRes = [], villageRes = [], mandaldum = [], districtdum = [], statedum = [], langdum = [];
//             let ex_villages = [], ex_mandals = [], ex_districts = [], states = [], mandalsinlist = [], districtinlist = [], statesinlist = [], villagesinlist = [];
//             if (mandal_ids.length) mandalsinlist = mandal_ids.map(j => +j.mandal_id);
//             if (district_ids.length) districtinlist = district_ids.map(j => +j.dist_id);
//             if (state_ids.length) statesinlist = state_ids.map(j => +j.state_id);
//             if (village_ids.length) villagesinlist = village_ids.map(j => +j.village_id)
//             if (village_ids.length) mandaldum = village_ids.map(j => +j.mandal_id)
//             if (mandal_ids.length) districtdum = mandal_ids.map(j => +j.dist_id)
//             if (district_ids) statedum = district_ids.map(j => +j.state_id)
//             if (state_ids) langdum = state_ids.map(j => +j.lang_id)
//             if (exclude) {
//                 if (village_ids.length) {
//                     ex_villages = villagesinlist
//                     mandalRes = mandaldum
//                     villageRes = []
//                 }
//                 if (mandal_ids.length) {
//                     ex_mandals = mandalsinlist.filter(item => !mandaldum.includes(item))
//                     districtRes = []
//                     mandal_ids.map((item) => { if (ex_mandals.includes(item.mandal_id)) districtRes.push(+item.dist_id) })
//                 }
//                 if (district_ids.length) {
//                     ex_districts = districtinlist.filter(item => !districtdum.includes(+item))
//                 }
//                 statesRes = statesinlist
//             }
//             else {
//                 villageRes = villagesinlist
//                 statesRes = statesinlist.filter(item => !statedum.includes(item))
//                 mandalRes = mandalsinlist.filter(item => !mandaldum.includes(item))
//                 districtRes = districtinlist.filter(item => !districtdum.includes(item))
//             }
//             lang_ids = lang_ids.filter(item => !langdum.includes(item))

//             statesRes = Array.from(new Set(statesRes))
//             districtRes = Array.from(new Set(districtRes))
//             mandalRes = Array.from(new Set(mandalRes))
//             villageRes = Array.from(new Set(villageRes))
//             ex_districts = Array.from(new Set(ex_districts))
//             ex_mandals = Array.from(new Set(ex_mandals))
//             ex_villages = Array.from(new Set(ex_villages))
//             return resolve({ lang_ids, state_ids: statesRes, district_ids: districtRes, mandal_ids: mandalRes, village_ids: villageRes, ex_villages, ex_mandals, ex_districts })
//         } catch (error) {

//             console.error(error);
//         }
//     })
// }
const getBrands = async() =>{
    try {
      const brandsResult = await api({
        url: 'user/sales_persons/getBrands',
        method:"POST",
        responseType:"json"
      })
      if(brandsResult?.code === 200){
        setBrandsList(brandsResult.data)
      }
    } catch (error) {
      console.error("Error @ getBrands Campaigns Table",error)
    }
  }
  const getCategory = async () => {
    try {
      let res = await api({
        url: '/user/campaign/name',
        method: 'GET',
        responseType: 'json'
      })
      setCampCategory(res.data);
    } catch (error) {
      if (error.response.status === 401)
        navigate("/")
    }

  }
  const getLocalheads = async() =>{
    try {
      let res = await api({
        url:"/user/sales_persons/getLocalHeads",
        method: "GET",
        responseType : "json"
      })
      setLocalHeadsList([{label: "None", value: 0},...res.data])
    } catch (error) {
      console.error("Error @ getLocalheads \n",error)
    }
  }
  const getCreativeNames = async (ids, campaign_id, type) => {
    try {
        let res = await api({
            url: "/lineitems/creative_Names",
            method: "POST",
            responseType: 'json',
            data: { ids, campaign_id, type }
        })
        setCreative_Names(res.data)

    } catch (error) {
        console.error(error)
        if (error.response.status === 401)
            navigate("/")
    }
}
const fun = (id, dept) => {
   
    if (dept === "category") {
        for (let i = 0; i < campCategory.length; i++) {
            if (campCategory[i].value === id) {
                return (campCategory[i].label)
            }
        }
        return "-"
    }
    
    if(dept === "brand"){
        for (let i = 0; i < brandsList.length; i++) {
            if (brandsList[i].value === id) {
                return (brandsList[i].label)
            }
        }
        return "-"
    }
    if(dept === "localHeads"){
        for (let i = 0; i < localHeadsList.length; i++) {
            if (localHeadsList[i].value === id) {
                return (localHeadsList[i].label)
            }
        }
        return "-"
    }
}
const handleDate = (item) => {
    let list = [...timeslots]
    item?.map((d1, index) => {
        return (
            <p key={index}>
                {list = [...list, { sdate: '', edate: '' }]}
                {list[index]['sdate'] = formatDateWithTime(d1.sdate)}
                {list[index]['edate'] = formatDateWithTime(d1.edate)}
            </p>
        )
    })
    timeslots = [...list]

}
const Header = () => {
    if (!initialRender) {
      if (startDateFormatted && endDateFormatted) {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        getData(HeaderSearch, 0);
        // downloadReport(HeaderSearch, 0, status, { startDateFormatted, endDateFormatted }, campaignType, x_filter, target_filter)
      } else {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        getData(HeaderSearch, 0);
        // downloadReport(HeaderSearch, 0, status, dateFilter, campaignType, x_filter, target_filter)
      }
    }
  }
  const handlePageClick = (event) => {
    if (startDateFormatted && endDateFormatted) {
      setCurrentPage(event.selected);
      getData(HeaderSearch, event.selected);
      // downloadReport(search, 0, status, { startDateFormatted, endDateFormatted }, campaignType, x_filter, target_filter);
    } else {
      setCurrentPage(event.selected);
      getData(HeaderSearch, event.selected);
      // downloadReport(search, 0, status, dateFilter, campaignType, x_filter, target_filter)
    }
  };
  const statusFilterChange = (e) => {
    setStatus(e.target.value);
    setCurrentPage(0);
    getData(search, 0, discStatusFilter, e.target.value);
    // downloadReport(search, 0, e.target.value, dateFilter, campaignType, x_filter, target_filter)
}
const discountStatusFilterChange = (e) =>{
    setDiscStatusFilter(+e.target.value);
    setCurrentPage(0)
    getData(search,0,+e.target.value)
}
  return (
      <div>
          <header class="flex items-center justify-between my-3 ">
              <h5>Discount Campaigns</h5>
          </header>
          <aside class="flex gap-3 ml-auto justify-content-end">
          <div>
                  <SlSelect
                      size="small"
                      placeholder="Select Discount Status"
                      name="discount_status"
                      onSlChange={discountStatusFilterChange}
                  >
                      <SlIcon library="lucide" name="list-checks" slot="prefix"></SlIcon>

                        <SlOption value="0">All</SlOption>
                        <SlOption key={'1'} value={'1'}>{'Approved'}</SlOption>
                        <SlOption key={'2'} value={'2'}>{'Pending'}</SlOption>
                        <SlOption key={'3'} value={'3'}>{'Rejeted'}</SlOption>
                  </SlSelect>
              </div>
              <div>
                  <SlSelect
                      size="small"
                      placeholder="Select Status"
                      name="status"
                      onSlChange={statusFilterChange}
                  >
                      <SlIcon library="lucide" name="list-checks" slot="prefix"></SlIcon>

                      <SlOption value="-1">All</SlOption>
                      {
                          campaignStatus.map(item => {
                              return <SlOption key={item.value} value={item.value}>{item.label}</SlOption>
                          })
                      }
                  </SlSelect>
              </div>
              </aside>
          <div className="my-4 table-responsive">
              <ScrollContainer>
                  <table className="table table-bordered tableNew">
                      <thead className="sticky top-0">
                          <tr>
                              <th></th>
                              <th>LineItem Name</th>
                              <th>POS</th>
                              <th>Actual Price</th>
                              <th>Discount Price</th>
                              <th className="th-width w100px">Daily/Total Budget</th>
                              <th>Discount</th>
                              <th style={{ width: "40px" }}></th>
                          </tr>
                      </thead>
                      {data?.length && !loader ? (
                          <tbody>
                              {data?.map((item, index) => {
                                  return (
                                      <tr key={item.campaign_id} className={"group/details hover:bg-slate-100"} >
                                          <td className="posrel pointer">

                                          <img className="svg-icon20" src={item.status === 1 ? createdSVG : item.status === 2 ? runningSVG : item.status === 3 ? pausedSVG : item.status === 4 ? completedSVG : item.status === 5 ? scheduledSVG : item.status === 6 ? approved : ""} />
                                          </td>
                                          <td className="p-2">
                                              <div class="category">
                                                  {<h6 class={item.type === "Editorial" ? "editorial" : item.type === "Local" ? "local" : "dfp"}>{item.type}</h6>}
                                                  <h6><sl-badge variant="neutral">{item.campaign_type || "-"}</sl-badge></h6>
                                                  { ((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.legalperson)) && item.discount_obj &&  !item.discount_obj?.rejMess && !item.discount_obj?.discApp ? <h6>Discount Pending</h6> : null}
                                                  {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.legalperson)) && item.discount_obj &&  item.discount_obj?.rejMess && !item.discount_obj?.discApp ? <h6 title={item.discount_obj?.rejMess}>Discount Rejected</h6> : null}
                                              </div>
                                              <h1 class="title success">

                                                  {
                                                      <div className="flex items-center gap-2 group/position">
                                                          {<span className="wgt-600">{item.campaign_name}</span>}

                                                      </div>
                                                  }
                                              </h1>
                                              <div class="executive">
                                                  <h5 class="duration flex-hor">{

                                                      <div className="flex gap-2 items-center group/start-date">
                                                          <span className="whitespace-nowrap"> {item.campaign_type === 'CPD' ? formatDateWithTime(item.start_date) : formatDateWithTime(item.start_date)}</span>

                                                      </div>
                                                  } - {
                                                          <div className="flex items-center gap-2 group/end-date">
                                                              <span className="whitespace-nowrap">{item.campaign_type === 'CPD' ? formatDateWithTime(item.end_date) : formatDateWithTime(item.end_date)}</span>

                                                          </div>
                                                      }</h5>
                                              </div>
                                          </td>

                                          <td className="p-2 wgt-600">

                                              {item.position}

                                          </td>
                                        <td className="p-2 wgt-600">
                                            ₹{item.discount_obj ? item.discount_obj?.actualPrice : 0}
                                        </td>
                                        <td className="p-2 wgt-600">
                                            ₹{item.discount_obj ? item.discount_obj?.discountPrice : 0}
                                        </td>

                                          <td>
                                              <div class="splitView">
                                                  <p>
                                                      {item.campaign_type === "CPD" ?
                                                          item.cpd
                                                          : item.daily_budget}
                                                  </p>
                                                  <div class="devider"></div>
                                                  <p>
                                                      {item.campaign_type === "CPD" ?
                                                          item.cpd
                                                          : item.total_budget}
                                                  </p>
                                              </div>
                                          </td>
                                          <td>{`${item?.discount_obj?.discsign ? '+' : '-'} ${item.discount_obj?.discount_no ? item.discount_obj?.discount_no + '%': 0 + '%'}`}</td>

                                          <td className="p-2 relative actionsTd" style={{ fontSize: "20px" }}>
                                              {<span style={{ fontSize: "20px" }} className={showActionsMenu === index ? "showMenu" : "hideMenu"}>
                                                  <sl-tooltip content="View LineItem" hoist>
                                                      <sl-icon-button
                                                          library="lucide"
                                                          name="view"
                                                          onClick={() => { editAction(index, item.campaign_id, "preview"); getCreativeNames(item.creative_ids, item.campaign_id, item.type, item.grouped); setTimeout(() => { setTarshow(true) }, 0) }}></sl-icon-button>
                                                  </sl-tooltip>
                                                  {!item.grouped && item.discount_obj && <sl-tooltip content="View Discount" hoist>
                                                      <sl-icon-button
                                                          library="lucide"
                                                          name="file-check"
                                                          onClick={() => { ViewDiscount(item.campaign_id, index); }}></sl-icon-button>
                                                  </sl-tooltip>}
                                              </span>}
                                              {showActionsMenu !== index ? <sl-tooltip content="Actions" hoist id="clickAction">
                                                  <sl-icon-button
                                                      library="lucide"
                                                      name="more-vertical"
                                                      onClick={() => { setShowActionsMenu(index) }}></sl-icon-button>
                                              </sl-tooltip> : <sl-tooltip content="Actions" hoist id="clickAction">
                                                  <sl-icon-button
                                                      library="lucide"
                                                      name="more-horizontal"
                                                      onClick={() => { setShowActionsMenu(-1) }}></sl-icon-button>
                                              </sl-tooltip>

                                              }
                                          </td>

                                      </tr>
                                  )
                              })}
                          </tbody>
                      ) : !data?.length && !loader ? (
                          <NoDataFound colspan="15" />
                      ) : (
                          <TableLoader colspan="15" />
                      )}
                  </table>
              </ScrollContainer>
          </div>
          <div className='right-absolute'>
              {totalPages > 1 && <Paginator
                  pageCount={totalPages}
                  handlePageClick={handlePageClick}
                  forcePage={currentPage}
              />}
          </div>
          <SlDrawer
              open={tarshow}
              onSlAfterHide={() => { setTarshow(false); setTargetdetails({}); setactual_target({}); setCreative_Names([]); setPreview({}); setactual_hidden_target({}); setHidden_target_preview({}); }}
              style={{ '--size': '1280px' }}>
              <label slot="label">{`${previewdata?.start?.campaign_name ? previewdata?.start?.campaign_name : ""}`}</label>
              <div>
                  <section className="flex gap-6">
                      <div className="basis-7/12 grid gap-6 grid-cols-2">
                          {
                              <>
                                  {previewdata.budget ? <>
                                      {<>
                                          <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                              <h6 className="mb-2">Campaign Creation</h6>

                                              <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">LineItem Name : </label>
                                                  <span>{previewdata.start.campaign_name}</span>
                                              </div>
                                              <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">LineItem Type : </label>
                                                  <span>{previewdata.start.campaign_type}</span>
                                              </div>
                                              <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">Type : </label>
                                                  <span>{previewdata.type}</span>
                                              </div>
                                              {previewdata.start.brand_id !== null && <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">Brand : </label>
                                                  <span>{previewdata.brand_name}</span>
                                              </div>}
                                          </section>
                                          <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                              <h6 className="mb-2">Budget</h6>
                                              {previewdata.budget.cpc_price > 0 && <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">CPC Price : </label>
                                                  <span>{previewdata.budget.cpc_price}</span>
                                              </div>}

                                              {previewdata.start.campaign_type === "CPD" && <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">CPD Price : </label>
                                                  <span>{previewdata.creatselect.cpd}</span>
                                              </div>}

                                              {previewdata.budget.cpm > 0 && <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">CPM Price : </label>
                                                  <span>{previewdata.budget.cpm}</span>
                                              </div>}

                                              {previewdata.budget.daily_budget > 0 && <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">Daily Budget : </label>
                                                  <span>{previewdata.budget.daily_budget}</span>
                                              </div>}

                                              {previewdata.budget.total_budget > 0 && <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">Total Budget : </label>
                                                  <span>{previewdata.budget.total_budget}</span>
                                              </div>}

                                              {previewdata.budget.daily_click_cap > 0 && <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">Daily Click Cap : </label>
                                                  <span>{previewdata.budget.daily_click_cap}</span>
                                              </div>}

                                              {previewdata.budget.daily_imp_cap > 0 && <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">Daily Impression Cap : </label>
                                                  <span>{previewdata.budget.daily_imp_cap}</span>
                                              </div>}

                                              {previewdata.budget.tot_click_cap > 0 && <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">Total Click Cap : </label>
                                                  <span>{previewdata.budget.tot_click_cap}</span>
                                              </div>}

                                              {previewdata.budget.tot_imp_cap > 0 && <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">Total Impression Cap : </label>
                                                  <span>{previewdata.budget.tot_imp_cap}</span>
                                              </div>}



                                          </section>
                                          <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                              <h6>Create Select</h6>
                                              {previewdata.creatselect.ad_code !== '' && <div className="flex justify-between mb-2"><label className="text-slate-500">Ad Code :</label> {previewdata.creatselect.ad_code}</div>}
                                              {previewdata.creatselect.line_item_code !== null && <div className="flex justify-between mb-2"><label className="text-slate-500">Line Item Code :</label> {previewdata.creatselect.line_item_code}</div>}
                                              {previewdata.creatselect.dfp_creative_ids !== null && <div className="flex justify-between mb-2"><label className="text-slate-500">DFP Creative Ids:</label> {previewdata.creatselect?.dfp_creative_ids?.split(',')?.map(item => <>{item}<br /></>)}</div>}
                                              {previewdata.creatselect.post_type !== null && <div className="flex justify-between mb-2"><label className="text-slate-500"> Post Type :</label> {previewdata.creatselect.post_type}</div>}
                                              {previewdata.creatselect.news_type !== null && <div className="flex justify-between mb-2"><label className="text-slate-500"> News Type :</label> {previewdata.creatselect.news_type}</div>}

                                              {previewdata.creatselect.creative_type !== '' && <div className="flex justify-between mb-2"><label className="text-slate-500">Creative Type  :</label> {previewdata.creatselect.creative_type}</div>}
                                              {previewdata.creatselect.frequency_cap > 0 && <div className="flex justify-between mb-2"><label className="text-slate-500">Frequency :</label>  {previewdata.creatselect.frequency_cap}</div>}
                                              {previewdata.creatselect.frequency_cap_type !== '' && <div className="flex justify-between mb-2"><label className="text-slate-500">Frequency Cap Type :</label>  {previewdata.creatselect.frequency_cap_type}</div>}
                                              <div className="flex justify-between mb-2"><label className="text-slate-500">Position : </label>{previewdata.creatselect.position}</div>
                                              {previewdata.creatselect.positiontype !== '' && <div className="flex justify-between mb-2"><label className="text-slate-500">Position Type :</label> {previewdata.creatselect.positiontype}</div>}
                                              {previewdata.creatselect.action_type !== null && <div className="flex justify-between mb-2"><label className="text-slate-500">Action type :</label> {actiontypeoptions[previewdata.creatselect.action_type]}</div>}
                                              {localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson ? <div className="flex justify-between mb-2"><label className="text-slate-500">Priority :</label> {+previewdata.creatselect.priority}</div> : null}
                                              {localStorage.getItem("role") === roles.ops ? <div className="flex justify-between mb-2"><label className="text-slate-500">Encryption  :</label> {previewdata.creatselect?.encryption ? "True" : "False"}</div> : null}
                                          </section>
                                          {previewdata.discount_obj ? <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                                <h6 className="mb-2">Discount</h6>
                                                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson || localStorage.getItem('role') === roles.legalperson)) && previewdata.discount_obj.discount_no ? <div className="flex justify-between mb-2"><label className="text-slate-500">Discount  :</label> {`${previewdata.discount_obj.discsign ? "+" : "-"} ${previewdata.discount_obj.discount_no}`}%</div> : null}
                                                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson || localStorage.getItem('role') === roles.legalperson)) && previewdata.discount_obj.actualPrice ?  <div className="flex justify-between mb-2"><label className="text-slate-500">Actual Price  :</label> {previewdata?.discount_obj?.actualPrice}</div> : null}
                                                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson || localStorage.getItem('role') === roles.legalperson)) && previewdata.discount_obj.discountPrice ?  <div className="flex justify-between mb-2"><label className="text-slate-500">After Discount :</label> {previewdata?.discount_obj?.discountPrice}</div> : null}
                                                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson || localStorage.getItem('role') === roles.legalperson)) && previewdata.discount_obj.discReas ?  <div className="flex justify-between mb-2"><label className="text-slate-500">Discount Reason  :</label> {previewdata.discount_obj.discReas}</div> : null}
                                                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson || localStorage.getItem('role') === roles.legalperson)) && previewdata.discount_obj.name ?  <div className="flex justify-between mb-2"><label className="text-slate-500">Discount Requested to  :</label> {previewdata.discount_obj.name}</div> : null}
                                                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson || localStorage.getItem('role') === roles.legalperson)) && previewdata.discount_obj.approvName ?  <div className="flex justify-between mb-2"><label className="text-slate-500">Discount Approved By  :</label> {previewdata?.discount_obj?.approvName}</div> : null}
                                                </section> : null}
                                          <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                              <h6 className="mb-2">Date</h6>
                                              <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">Start Date :</label>
                                                  <span>{previewdata.start.campaign_type === 'CPD' ? formatDateWithTime(previewdata.date.start_date) : formatDateWithTime(previewdata.date.start_date)}</span>
                                              </div>
                                              <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">End Date :</label>
                                                  <span>{previewdata.start.campaign_type !== 'CPD' ? formatDateWithTime(previewdata.date.end_date) : formatDateWithTime(previewdata.date.end_date)}</span>
                                              </div>
                                              {previewdata.date.datelist.length !== 0 ? <div className="flex justify-between mb-2">
                                                  <label className="text-slate-500">Day Time Slots :</label>
                                                  {previewdata.date.datelist.length !== 0 ? handleDate(previewdata.date.datelist) : <div></div>}</div> : null}
                                              <p>{previewdata.date.datelist.length !== 0 ? (timeslots.length > 0 ? timeslots.map((item, i) => (<p key={i}> {item.sdate} {<br />}  {item.edate}</p>)) : null) : null}</p>
                                          </section>
                                          {Object.keys(targetdetails).length ? <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                              <h6 className="mb-2">Target</h6>
                                              {actual_target.lang_ids?.length > 0 && <div className="flex justify-between mb-2"><label className="text-slate-500">Languages :</label> </div>}
                                              {(Array.isArray(actual_target.lang_ids) && actual_target.lang_ids.length > 0) && targetdetails.lang_ids.map((item, i) => {
                                                  if (actual_target.lang_ids.includes(item))
                                                      return <span key={i}>{langoptions[item]}</span>
                                              })}
                                              {(Array.isArray(actual_target.state_ids) && actual_target.state_ids.length > 0) && (<div>
                                                  <label className="text-slate-500">States : </label>
                                                  {targetdetails.state_ids.filter(stateId => ( targetdetails.district_ids.length === 0 || targetdetails.district_ids.some(entry => +entry.state_id !== +stateId.state_id))).map((item, i) => {
                                                      if (actual_target.state_ids.includes(item.state_id))
                                                          return <p>{item.state_name}</p>
                                                  }
                                                  )}
                                              </div>)}
                                              {(!targetdetails.exclude && Array.isArray(actual_target.district_ids) && actual_target.district_ids.length > 0) && <div>
                                                  {<label className="text-slate-500">Districts : </label>}
                                                  {targetdetails.district_ids.map((item, i) => {
                                                      if (actual_target.district_ids.includes(item.dist_id))
                                                          return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                                  }
                                                  )}
                                              </div>}
                                              {(Array.isArray(actual_target.ex_districts) && actual_target.ex_districts.length > 0) && <div>
                                                  {<label className="text-slate-500">Excluded Districts : </label>}
                                                  {targetdetails.district_ids.map((item, i) => {
                                                      if (actual_target.ex_districts.includes(item.dist_id))
                                                          return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                                  }
                                                  )}
                                              </div>}
                                              {(Array.isArray(targetdetails.constituency_ids) && targetdetails.constituency_ids.length > 0) && <div>
                                                    {targetdetails.exclude ? <label className="text-slate-500">Excluded Constituencies : </label> : <label className="text-slate-500">Constituencies : </label>}
                                                    {targetdetails.constituency_ids.map((item, i) => {
                                                            return <p key={i}>{`${item.const_name}(C), ${item.district_name}(D)`}</p>
                                                    }
                                                    )}
                                                </div>}
                                              {(!targetdetails.exclude && Array.isArray(actual_target.mandal_ids) && actual_target.mandal_ids.length > 0) && <div>
                                                  {<label className="text-slate-500">Mandals : </label>}
                                                  {targetdetails.mandal_ids.map((item, i) => {
                                                      if (actual_target.mandal_ids.includes(item.mandal_id))
                                                          return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                                  }
                                                  )}
                                              </div>}
                                              {(Array.isArray(actual_target.ex_mandals) && actual_target.ex_mandals.length > 0) && <div>
                                                  {<label className="text-slate-500">Excluded Mandals : </label>}
                                                  {targetdetails.mandal_ids.map((item, i) => {
                                                      if (actual_target.ex_mandals.includes(item.mandal_id))
                                                          return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                                  }
                                                  )}
                                              </div>}
                                              {(Array.isArray(actual_target.village_ids) && actual_target.village_ids.length > 0) && <div>
                                                  {<label className="text-slate-500">villages : </label>}
                                                  {targetdetails.village_ids.map((item, i) => {
                                                      if (actual_target.village_ids.includes(item.village_id))
                                                          return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                                  }
                                                  )}
                                              </div>}
                                              {(Array.isArray(actual_target.ex_villages) && actual_target.ex_villages.length > 0) && <div>
                                                  {<label className="text-slate-500">Excluded villages : </label>}
                                                  {targetdetails.village_ids.map((item, i) => {
                                                      if (actual_target.ex_villages.includes(item.village_id))
                                                          return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                                  }
                                                  )}
                                              </div>}
                                              {(Array.isArray(targetdetails.app_category) && targetdetails.app_category.length > 0) && <div>
                                                  {<label className="text-slate-500">App Category : </label>}
                                                  {targetdetails.app_category.map((item, i) => (

                                                      <p key={i}> {appCategoryOptions[item]}</p>
                                                  )
                                                  )}
                                              </div>}
                                              {(Array.isArray(targetdetails.minspend) && targetdetails.minspend.length > 0) && <div>
                                                  {<label className="text-slate-500">Minimum Spend : </label>}
                                                  {targetdetails.minspend.map((item, i) => (

                                                      <p key={i}>{item}</p>
                                                  )
                                                  )}
                                              </div>}
                                              {previewdata.target ? <div>
                                                  {previewdata.target.min_age > 0 && <p><label className="text-slate-500">Min Age</label> : {previewdata.target.min_age}</p>}
                                                  {previewdata.target.max_age > 0 && <p><label className="text-slate-500">Max Age</label> : {previewdata.target.max_age}</p>}
                                                  {previewdata.target.os !== '' && <p><label className="text-slate-500">OS</label> : {osOptions[previewdata.target.os]}</p>}
                                                  {genderOptions[targetdetails.gender] !== null && <p><label className="text-slate-500">Gender</label> : {genderOptions[targetdetails.gender]} </p>}
                                              </div> : null}
                                          </section> : null}
                                          {localStorage.getItem('role') === roles.ops && Object.keys(hidden_target_preview).length ? <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                              <h6 className="mb-2">Hidden Target</h6>
                                              {actual_hidden_target.lang_ids?.length > 0 && <div className="flex justify-between mb-2"><label className="text-slate-500">Languages :</label> </div>}
                                              {(Array.isArray(actual_hidden_target.lang_ids) && actual_hidden_target.lang_ids.length > 0) && hidden_target_preview.lang_ids.map((item, i) => {
                                                  if (actual_hidden_target.lang_ids.includes(item))
                                                      return <span key={i}>{langoptions[item]}</span>
                                              })}
                                              {(Array.isArray(actual_hidden_target.state_ids) && actual_hidden_target.state_ids.length > 0) && (<div>
                                                  <label className="text-slate-500">States : </label>
                                                  {hidden_target_preview.state_ids.map((item, i) => {
                                                      if (actual_hidden_target.state_ids.includes(item.state_id))
                                                          return <p>{item.state_name}</p>
                                                  }
                                                  )}
                                              </div>)}
                                              {(Array.isArray(actual_hidden_target.district_ids) && actual_hidden_target.district_ids.length > 0) && <div>
                                                  {<label className="text-slate-500">Districts : </label>}
                                                  {hidden_target_preview.district_ids.map((item, i) => {
                                                      if (actual_hidden_target.district_ids.includes(item.dist_id))
                                                          return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                                  }
                                                  )}
                                              </div>}
                                              {(Array.isArray(hidden_target_preview.constituency_ids) && hidden_target_preview.constituency_ids.length > 0) && <div>
                                                    {hidden_target_preview.exclude ? <label className="text-slate-500">Excluded Constituencies : </label> : <label className="text-slate-500">Constituencies : </label>}
                                                    {hidden_target_preview.constituency_ids.map((item, i) => {
                                                            return <p key={i}>{`${item.const_name}(C), ${item.district_name}(D)`}</p>
                                                    }
                                                    )}
                                                </div>}
                                              {(Array.isArray(actual_hidden_target.mandal_ids) && actual_hidden_target.mandal_ids.length > 0) && <div>
                                                  {<label className="text-slate-500">Mandals : </label>}
                                                  {hidden_target_preview.mandal_ids.map((item, i) => {
                                                      if (actual_hidden_target.mandal_ids.includes(item.mandal_id))
                                                          return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                                  }
                                                  )}
                                              </div>}
                                              {(Array.isArray(actual_hidden_target.village_ids) && actual_hidden_target.village_ids.length > 0) && <div>
                                                  {<label className="text-slate-500">villages : </label>}
                                                  {hidden_target_preview.village_ids.map((item, i) => {
                                                      if (actual_hidden_target.village_ids.includes(item.village_id))
                                                          return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                                  }
                                                  )}
                                              </div>}
                                          </section> : null}
                                      </>
                                      }
                                  </> : <div></div>}
                              </>
                          }

                      </div>
                      {previewdata.creatselect && <section className="basis-5/12 rounded-2xl overflow-hidden">
                          {<> {(creative_Names.length > 0 ?
                              <Swiper
                                  spaceBetween={0}
                                  pagination={true}
                                  navigation={true}
                                  modules={[Navigation, Pagination]}
                                  className="mySwiper"
                                  style={{ width: "460px" }}>
                                  {creative_Names.map((campPreview) => <SwiperSlide><lineItemCreativeContext.Provider value={{ campPreview }}><PreviewFrameEdit showPreview={true} /></lineItemCreativeContext.Provider></SwiperSlide>)}</Swiper> : null)} </>}
                      </section>}
                  </section>

              </div>

          </SlDrawer>
          <SlDrawer
              open={Object.keys(discountObjDetails).length}
              onSlAfterHide={() => { setDiscountObjDetails({}); setRejectClick(false); setRejectMessage("") }}>
              <label slot="label">{`${discountObjDetails?.campaign_name ? discountObjDetails?.campaign_name : ""}`}</label>
              {/* <div className="flex justify-between mb-2">
                  <label className="text-slate-500">Order Name : </label>
                  <span>{discountObjDetails.order_name}</span>
              </div> */}
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">LineItem Name : </label>
                  <span>{discountObjDetails.campaign_name}</span>
              </div>
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">LineItem Type : </label>
                  <span>{discountObjDetails.campaign_type}</span>
              </div>
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">Company Name : </label>
                  <span>{discountObjDetails.company_name}</span>
              </div>
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">Sales Name : </label>
                  <span>{discountObjDetails.sales_name}</span>
              </div>
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">CST Name : </label>
                  <span>{discountObjDetails.cst_name}</span>
              </div>
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">Type : </label>
                  <span>{discountObjDetails.type}</span>
              </div>
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">Actual Price : </label>
                  <span>{`₹${+discountObjDetails.actualPrice}`}</span>
              </div>
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">Discount Requested : </label>
                  <span>{`${discountObjDetails.discsign ? '+' : '-'} ₹${(Math.abs(discountObjDetails.actualPrice - discountObjDetails.discountPrice)).toFixed(2)} (${discountObjDetails.discsign ? '+' : '-'} ${discountObjDetails.discount_no}%)`}</span>
              </div>
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">After Discount : </label>
                  <span>{`₹${discountObjDetails.discountPrice}`}</span>
              </div>
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">Requested to : </label>
                  <span>{discountObjDetails.name}</span>
              </div>
              <div className="flex justify-between mb-2">
                  <label className="text-slate-500">Approved By : </label>
                  <span>{discountObjDetails.approvName}</span>
              </div>
              {discountObjDetails.discReas ? <div className="flex justify-between mb-2">
                  <label className="text-slate-500">Discount Reason : </label>
                  <span>{discountObjDetails.discReas}</span>
              </div> : null}
              {discountObjDetails.rejMess ? <div className="flex justify-between mb-2">
                  <label className="text-slate-500">Rejected Message : </label>
                  <span>{discountObjDetails.rejMess}</span>
              </div> : null}
              {rejectClick ? (
                  <div className="flex mb-2">
                    <label className="w-40 text-slate-500">Rejected Reason : </label>
                    <p className="w-72">{rejectMessage}</p>
                  </div>
                ) : null}
                
                  {approveClick ? (
                    <div className="flex mb-2">
                      <label className="w-40 text-slate-500">Approve Reason : </label>
                      <p className="w-72">{approveMessage}</p>
                    </div>
                  ) : null}
              {(localStorage.getItem('role') === roles.salesperson || localStorage.getItem('role') === roles.legalperson) && !discountObjDetails.discApp && !discountObjDetails.rejMess ? <div >
              <div className="d-flex gap-3">
                  {(!rejectClick && !approveClick )&& <button
                    type="submit"
                    className="btn btn-success w-1/2"
                    onClick={() => setApproveClick(true)}
                  >
                    Approve
                  </button>}
                  {(!rejectClick && !approveClick )&& (
                    <button
                      className="btn btn-danger w-1/2"
                      onClick={() => setRejectClick(true)}
                    >
                      Reject
                    </button>
                  )}
                  </div>
                  {rejectClick && (
                    <>
                    <div>
                      <input
                        placeholder="Reject is Required"
                        className="form-control mb-2"
                        type="text"
                        name="rejectMessage"
                        value={rejectMessage}
                        onChange={(e) => setRejectMessage(e.target.value)}
                      />
                      </div>
                      <div className="d-flex gap-3">
                      <button
                        className="btn btn-danger w-full"
                        onClick={() => ApproveRejectDisc(discountObjDetails,"reject")}
                        disabled={!rejectMessage}
                      >
                        Reject
                      </button>
                      <button
                        className="btn btn-danger w-full"
                        onClick={()=>{setRejectClick(false); setRejectMessage("")}}
                      >
                        Cancel
                      </button>
                      </div>
                      
                    </>
                  )}
                  {approveClick && (
                    <>
                    <div>
                      <input
                        placeholder="Approve message is Required"
                        className="form-control mb-2"
                        type="text"
                        name="rapproveMessage"
                        value={approveMessage}
                        onChange={(e) => setApproveMessage(e.target.value)}
                      />
                    </div>
                      <div className="d-flex gap-2">
                      <button
                        className="btn btn-success w-full"
                        onClick={() => ApproveRejectDisc(discountObjDetails, "approve")}
                        disabled={!approveMessage}
                      >
                        Approve
                      </button>
                      <button
                        className="btn btn-danger w-full"
                        onClick={()=>{setApproveClick(false); setApproveMessage("")}}
                      >
                        Cancel
                      </button>
                      </div>
                      
                    </>
                  )}</div> : null}

          </SlDrawer>
      </div>
  )
}

export default DiscountApproveCampaigns

